import membermateConfig from "../config/membermate.config.json";

export default {
  url: function (path, urlParams) {
    let result = membermateConfig.urls;

    try {
      let pathSteps = path.split(".");

      pathSteps.map((step) => {
        result = result[step];
        return null;
      });
    } catch (exception) {
      result = path;
    }

    if (result && urlParams) {
      Object.keys(urlParams).map((urlParamKey) => {
        result = result.replace(`:${urlParamKey}`, urlParams[urlParamKey]);
        return null;
      });
    }

    //console.log("config", result);

    return result;
  },
};
